import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserModal = ({ show, onHide, user, roles, onSuccess, onError }) => {
  const [userForm, setUserForm] = useState({
    username: '',
    email: '',
    password: '',
    role_id: '',
    status: 'Active'
  });
  const [loading, setLoading] = useState(false);

  const API_BASE = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    if (user) {
      setUserForm({
        username: user.username,
        email: user.email,
        password: '',
        role_id: user.role_id || '',
        status: user.status
      });
    } else {
      setUserForm({
        username: '',
        email: '',
        password: '',
        role_id: '',
        status: 'Active'
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const isUpdate = !!user;
      const endpoint = isUpdate ? 'update_user.php' : 'create_users.php';
      
      const requestData = isUpdate 
        ? { ...userForm, user_id: user.user_id }
        : userForm;

      const response = await axios.post(`${API_BASE}/${endpoint}`, 
        requestData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        onSuccess();
      } else {
        onError(response.data.error || `Failed to ${isUpdate ? 'update' : 'create'} user`);
      }
    } catch (error) {
      onError(error.response?.data?.error || `Failed to ${user ? 'update' : 'create'} user`);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              <i className="bi bi-person me-2"></i>
              {user ? 'Edit User' : 'Add New User'}
            </h5>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onHide}
              disabled={loading}
            ></button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row g-3">
                {user && (
                  <div className="col-12">
                    <label className="form-label">User ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user.user_id}
                      disabled
                    />
                    <div className="form-text">User ID cannot be changed</div>
                  </div>
                )}
                <div className="col-12">
                  <label className="form-label">Username *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userForm.username}
                    onChange={(e) => setUserForm({...userForm, username: e.target.value})}
                    required
                    disabled={loading}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={userForm.email}
                    onChange={(e) => setUserForm({...userForm, email: e.target.value})}
                    disabled={loading}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">
                    {user ? 'New Password (leave blank to keep current)' : 'Password *'}
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    value={userForm.password}
                    onChange={(e) => setUserForm({...userForm, password: e.target.value})}
                    required={!user}
                    disabled={loading}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Role</label>
                  <select
                    className="form-select"
                    value={userForm.role_id}
                    onChange={(e) => setUserForm({...userForm, role_id: e.target.value})}
                    disabled={loading}
                  >
                    <option value="">No Role</option>
                    {roles.filter(r => r.is_active).map(role => (
                      <option key={role.role_id} value={role.role_id}>
                        {role.role_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={userForm.status}
                    onChange={(e) => setUserForm({...userForm, status: e.target.value})}
                    disabled={loading}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Locked">Locked</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onHide}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    {user ? 'Updating...' : 'Creating...'}
                  </>
                ) : (
                  user ? 'Update User' : 'Create User'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserModal;